// extracted by extract-css-chunks-webpack-plugin
module.exports = {"offline":"offline-3pQgqpzH","offlineBox":"offlineBox-1DFbJD_x","icon":"icon-wEYO_I22","btn":"btn-1wRViF1l"};